module.exports = __webpack_public_path__ + "static/media/exp_beach_1.a8ed54e1.svg";